export function parseJson(str?: string) {
	if (!str) return;
	try {
		return JSON.parse(str);
	} catch (e) {
		console.error(e);
		return false;
	}
}
